<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><a id="ttl"></a>The New American Economy</h1>
<p class="noindent"> </p>
<h2 class="front">The Failure of Reaganomics and a New Way Forward</h2>
<p class="noindent"> </p>
<p class="author1">Bruce Bartlett</p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="image"><img alt="Image" src="OEBPS/html/images/logo.jpg"/></p>
<p class="noindent"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230249226_02_ttl.vue?41dc7028